import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = (isPartner = false, isSupplyChainManager = false, isFacilityManager) => [
  { label: 'S.N', value: 'id' },
  {
    label: 'Material Hub',
    value: 'name',
  },
  /* {
    label: 'Birthday',
    value: 'birthday',
  },
  {
    label: 'Gender',
    value: 'gender',
  },*/
  /* {
    label: 'Email Address',
    value: 'email',
  }, */
  // {
  //   label: 'Franchisee',
  //   value: 'franchiseName',
  // },
  {
    label: 'Supply chain',
    value: 'franchiseName',
  },
  // {
  //   label: 'Factory Type',
  //   value: 'facilityType',
  // },
  {
    label: 'type',
    value: 'facilityType',
  },
  {
    label: 'lifetime',
    value: 'lifeTimePerformance1',
  },
  {
    label: 'Annual',
    value: 'avgYearlyCollected1',
  },
  {
    label: 'monthly',
    value: 'avgMonthlyCollected1',
  },
  {
    label: 'Daily',
    value: 'avgDailyCollected1',
  },
  {
    label: 'status',
    value: 'status1',
  },
  // {
  //   label: 'Registered On',
  //   value: 'createdAt',
  // },
  /* {
    label: 'Audited',
    value: 'flexible',
  },
  {
    label: 'Balance',
    value: 'street',
  }, */
  // {
  //   action: ['edit'],
  // },
]

// const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)
const roleColumns = (isPartner = false, isSupplyChainManager = false, isFacilityManager) => {
  return columnGenerators(header(isPartner, isSupplyChainManager, isFacilityManager))
}

export { roleColumns }
